<script setup>
import { ref, onMounted, watchEffect, computed, watch } from 'vue'
import { Progress } from 'vant'

const props = defineProps({
  // 配置项
  data: {
    type: Array,
    default: () => [],
  },
})

const barRef = ref(null)
const myChart = ref()

const yData = ref([])
const completeData = ref([])
const uncompleteData = ref([])

const handleCalculatePercentage = (item) => {
  // 完成人数
  const completePerson = item.completePerson
  // 总人数
  const totalPerson = item.totalPerson
  // 未完成人数
  const unCompletePerson = totalPerson - completePerson
  // 填报条数
  const submitCount = item.submitCount

  if (totalPerson === 0) {
    return {
      completePersonPercentage: 0,
      totalPersonPercentage: 0,
      unCompletePersonPercentage: 0,
      submitCountPercentage: 0,
    }
  }

  // 计算最大值
  const maxValue = Math.max(
    completePerson,
    totalPerson,
    unCompletePerson,
    submitCount
  )

  // 计算百分比
  const completePersonPercentage = (completePerson / maxValue) * 100
  const totalPersonPercentage = (totalPerson / maxValue) * 100
  const unCompletePersonPercentage = (unCompletePerson / maxValue) * 100
  const submitCountPercentage = (submitCount / maxValue) * 100

  // 返回结果
  return {
    completePersonPercentage,
    totalPersonPercentage,
    unCompletePersonPercentage,
    submitCountPercentage,
  }
}

watchEffect(() => {
  props.data?.forEach((item) => {
    yData.value.push(`${item.firstName}-${item.secondName}-${item.thirdName}`)
    completeData.value.push(item.completePerson)
    uncompleteData.value.push(item.totalPerson - item.completePerson)
  })

  // myChart.value?.setOption(option)
})

onMounted(() => {
  if (barRef.value) {
    myChart.value = echarts.init(barRef.value)
    option && myChart.value.setOption(option)
  }
})

watch(
  () => props.data,
  () => {
    myChart.value?.setOption(option)
  }
)
</script>
<template>
  <div class="bar-wrap">
    <div v-show="data?.length > 0" class="legen-wrap">
      <div class="legen-item">总人数</div>
      <div class="legen-item">已填人员</div>
      <div class="legen-item">未填人员</div>
      <div class="legen-item">填报条数</div>
    </div>
    <div v-for="item in data" class="">
      <p class="title">
        {{ `${item.firstName}-${item.secondName}-${item.thirdName}` }}
      </p>
      <!-- 总人数  -->
      <Progress
        v-show="item.totalPerson !== 0"
        class="progress-item"
        :pivot-text="item.totalPerson + ''"
        :percentage="handleCalculatePercentage(item).totalPersonPercentage"
        color="#e9b4ff"
        stroke-width="10"
      />
      <!-- 已填人员  -->
      <Progress
        v-show="item.completePerson && item.completePerson !== '0'"
        class="progress-item"
        :pivot-text="item.completePerson + ''"
        :percentage="handleCalculatePercentage(item).completePersonPercentage"
        color="#4b8cff"
        stroke-width="10"
      />
      <!-- 未填人员 -->
      <Progress
        v-show="item.totalPerson !== item.completePerson"
        class="progress-item"
        :pivot-text="item.totalPerson - item.completePerson + ''"
        :percentage="handleCalculatePercentage(item).unCompletePersonPercentage"
        color="#67d8ca"
        stroke-width="10"
      />
      <!-- 填报条数 -->
      <Progress
        v-show="item.submitCount !== '0'"
        class="progress-item"
        :pivot-text="item.submitCount"
        :percentage="handleCalculatePercentage(item).submitCountPercentage"
        color="#ffa00b"
        stroke-width="10"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.bar-wrap {
  position: relative;
  padding-bottom: 40px;
  margin-bottom: 50px;

  &::after {
    position: absolute;
    content: '';
    left: -26px;
    right: -26px;
    bottom: 0;
    height: 6px;
    background: #eaeaea;
    opacity: 0.5;
  }

  ::v-deep {
    .van-progress {
      box-sizing: border-box;
      background: none !important;
      .van-progress__pivot {
        margin-left: 18%;
        background: none !important;
        color: #333333;
        font-size: 17px;
      }
    }
  }

  .legen-wrap {
    display: flex;
    justify-content: flex-end;
    font-size: 24px;
    color: #333333;

    .legen-item {
      position: relative;
      margin-left: 40px;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        left: -20px;
        width: 14px;
        height: 14px;
      }

      &:nth-last-of-type(1)::before {
        background-color: #ffa00b;
      }
      &:nth-last-of-type(2)::before {
        background-color: #67d8ca;
      }
      &:nth-last-of-type(3)::before {
        background-color: #4b8cff;
      }
      &:nth-last-of-type(4)::before {
        background-color: #e9b4ff;
      }
    }
  }

  .title {
    margin-top: 24px;
    font-size: 24px;
    color: #333333;
  }

  .progress-item {
    width: 80%;
    margin-top: 20px;
  }
}
</style>
